import type { ColorTheme, ColorThemeDefinition, ColorThemeId } from "./color-theme";

export const FALLBACK_COLOR_THEME_ID = "classic" satisfies ColorThemeId;

const colorThemeRegistry = {
  classic: {
    label: "Classic",
    description: "The neutral palette the app has shipped with.",
    preview: {
      background: "oklch(1 0 0)",
      primary: "oklch(0.205 0 0)",
      accent: "oklch(0.97 0 0)",
      sidebar: "oklch(0.985 0 0)",
    },
  },
  default: {
    label: "Default",
    description: "The design system's slate palette with Istari blue accents in light and dark.",
    preview: {
      background: "#ffffff",
      primary: "#0074e1",
      accent: "#f1f5f9",
      sidebar: "#f8fafc",
    },
  },
} satisfies Record<ColorThemeId, ColorThemeDefinition>;

export function listColorThemes(): ColorTheme[] {
  return (Object.keys(colorThemeRegistry) as ColorThemeId[]).map(colorThemeById);
}

export function isColorThemeId(value: unknown): value is ColorThemeId {
  return typeof value === "string" && Object.hasOwn(colorThemeRegistry, value);
}

export function colorThemeById(id: ColorThemeId): ColorTheme {
  return { id, ...colorThemeRegistry[id] };
}
